import type { ComponentChildren } from 'preact';
import { BottomNav, type BottomNavProps } from './BottomNav';
import './NavZone.css';

export interface NavZoneProps extends BottomNavProps {
  /** A pre-built <Strip .../> element, or omitted entirely (not just
   *  empty) for a tab with no sub-views — the strip only ever occupies
   *  space when there's something to switch. Left as a plain
   *  ComponentChildren slot (rather than NavZone itself being generic
   *  over the strip's item-id type) so each call site's <Strip<Id>>
   *  keeps its own concrete id type — see App.tsx's per-route switch. */
  strip?: ComponentChildren;
}

// The persistent bottom chrome: the optional Strip (see Strip.tsx's own
// header for why it's built once and reused) stacked directly above the
// BottomNav, both inside one bordered zone — matches the blessed reference
// mock's `.navzone` (`.subnav` + `.nav`) exactly.
export function NavZone({ strip, ...navProps }: NavZoneProps) {
  return (
    <div class="nav-zone">
      {strip ?? null}
      <BottomNav {...navProps} />
    </div>
  );
}
